import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CompanyStatementsGQL, queryFn } from './queryFn';

/**
 * This hook returns the statements for the given company,
 * You can optionally specify which statement names to filter by
 */
export const useCompanyStatements = <ReturnDataType = CompanyStatementsGQL>({
  canonicalURL,
  names,
  options,
}: {
  canonicalURL: string;
  names?: Readonly<string[]>;
  options?: Omit<
    UseQueryOptions<
      CompanyStatementsGQL,
      unknown,
      ReturnDataType,
      [string, string, Readonly<string[]> | undefined]
    >,
    'queryKey' | 'queryFn'
  >;
}) => {
  const query = useQuery({
    queryKey: ['COMPANY_STATEMENTS', canonicalURL, names],
    queryFn,
    ...options,
  });

  return query;
};
